export default __webpack_public_path__ + "static/media/airInActiveIcon.0ba11736.svg";